import React from 'react';
import { Collapse } from 'react-bootstrap';
//import moment from 'moment';
import ReservationScroll from './ReservationScroll';
import MediaQuery from 'react-responsive';
import LoaderImg from '../../images/ajax_loader.gif';
import './reservation.css';

const ReservationDates = (props) => {
    let {
        reservationDates = [],
        selectedReserveDate,
        cart,
        isReserveLoading = false,
        selectedReservation,
        dayConflictsMsg = false,
    } = props.reservations;

    let { itineraryMap } = props.services;
    let { ShipboardCurrencyCode = 'USD' } = props;
    let reservationDatesCards = null;
    let isThermal = props.selectedService.serviceGroup === 'relaxationareas';
    let timeSlots = selectedReserveDate
        ? reservationDates.find((date) => date.dateOfService === selectedReserveDate.dateOfService)
        : [];
    const onCardClick = (date) => {
        props.onCardClick(date);
        //props
    };

    const onThermalReserve = (date, inCart) => {
        props.onCardClick(date, inCart);
        //props.onReserveService(date[0],inCart);
    };
    let minimumPrice;
    if (reservationDates.length > 0) {
        minimumPrice = reservationDates[0].minPrice;
        reservationDates.reduce(function(accumulator, currentValue) {
            if (currentValue.minPrice < minimumPrice) {
                minimumPrice = currentValue.minPrice;
            }
        });
    }
    if (reservationDates && !isThermal) {
        reservationDatesCards = reservationDates.map(function(date, index) {
            let isSelectedCard =
                selectedReserveDate &&
                // eslint-disable-next-line eqeqeq
                (selectedReserveDate[0].treatmentId == date[0].treatmentId &&
                    selectedReserveDate[0].formattedDate === date[0].formattedDate);
            let _port = itineraryMap
                ? itineraryMap.find((port) => port.date == date[0].serviceDate)
                : '';
            let location = _port
                ? _port.portName === 'At Sea'
                    ? _port.portName
                    : _port.portName.split(',')[0]
                : '';
            return (
                <li key={date[0].formattedDate} className="col-12 col-md-4 i-pad-10">
                    {minimumPrice === date.minPrice ? (
                        <span className="price">
                            <span className="price-tag font-size-p0 gotham-xn-medium">
                                Best Price
                            </span>
                        </span>
                    ) : (
                        ' '
                    )}
                    <button
                        className={`filter-benefits-button align-center availability-date-card  reservation-card datecard-hover ${
                            isSelectedCard ? 'selected-day-card' : ''
                        }`}
                        onClick={onCardClick.bind(this, date)}
                        aria-expanded={isSelectedCard}>
                        {minimumPrice === date.minPrice && (
                            <span className="visuallyhidden">Best Price</span>
                        )}
                        <div
                            className="Reserve-card-date font-size-p2 gotham-xn-medium"
                            data-test-id="reservation-card-date">
                            {date[0].formattedDate}
                        </div>
                        <div className="reserve-card-content">
                            <div
                                className="Reserve-card-port font-size-p2 gotham-xn-medium no-pad-margin"
                                data-test-id="reservation-card-port">
                                {location}
                            </div>
                            <div className="Reserve-card-price font-size-p2 gotham-xn-medium">
                                from{' '}
                                <sup className="font-size-p0 gotham-xn-medium">
                                    {' '}
                                    {`${props.ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} `}
                                </sup>
                                <span
                                    className="font-size-p10 gotham-xn-medium"
                                    data-test-id="reservation-card-price">
                                    {date.minPrice}
                                </span>
                            </div>
                            <p className="Reserve-card-times-text font-size-p2 gotham-xn-medium no-pad-margin title-hover d-none d-md-inline">
                                {`${isSelectedCard ? 'Hide Times' : 'View Available Times'}`}
                            </p>
                            <div className="Reserve-card-times-text font-size-p2 gotham-xn-medium no-pad-margin link-underline d-block d-md-none">
                                {`${isSelectedCard ? 'Hide Times' : 'Select a Time'}`}
                            </div>
                        </div>
                    </button>
                    <span class="reservation-arrow"></span>
                    <Collapse
                        in={
                            selectedReserveDate &&
                            selectedReserveDate[0].treatmentId === date[0].treatmentId &&
                            selectedReserveDate[0].formattedDate === date[0].formattedDate
                        }>
                        <div className="availability-collapse-container headline-gray-e6-bg">
                            <MediaQuery minWidth={768}>
                                {(matches) => (
                                    <ReservationScroll
                                        ShipboardCurrencyCode={props.ShipboardCurrencyCode}
                                        dayConflictsMsg={dayConflictsMsg}
                                        selectedReservation={selectedReservation}
                                        isReserveLoading={isReserveLoading}
                                        cart={cart}
                                        onReserveService={props.onReserveService}
                                        timeSlots={timeSlots}
                                        displayNavButtons={matches}
                                        selectedReserveDate={
                                            selectedReserveDate
                                        }></ReservationScroll>
                                )}
                            </MediaQuery>
                        </div>
                    </Collapse>
                </li>
            );
        });
    }

    if (reservationDates && isThermal) {
        reservationDatesCards = reservationDates.map((date, i) => {
            let inCartClass = cart.find(
                (cartItem) =>
                    cartItem.serviceDate === date[0].serviceDate &&
                    cartItem.treatmentId === date[0].treatmentId,
            )
                ? 'in-cart-item'
                : '';
            let _port = itineraryMap
                ? itineraryMap.find((port) => port.date == date[0].serviceDate)
                : '';
            let location = _port
                ? _port.portName === 'At Sea'
                    ? _port.portName
                    : _port.portName.split(',')[0]
                : '';

            return (
                <li key={date[0].formattedDate} className="col-md-4">
                    {minimumPrice === date.minPrice ? (
                        <span className="thermal-price">
                            <span className="price-tag font-size-p0 gotham-xn-medium">
                                Best Price
                            </span>
                        </span>
                    ) : (
                        ' '
                    )}
                    <button
                        className={`filter-benefits-button align-center availability-date-card  reservation-card ${
                            inCartClass ? 'selected-day-thermal-card' : ''
                        }`}
                        onClick={onThermalReserve.bind(this, date, inCartClass)}>
                        <div className="Reserve-card-date font-size-p2 gotham-xn-medium">
                            {date[0].formattedDate}
                        </div>
                        <div className="reserve-card-content">
                            {props.isReserveLoading &&
                            selectedReservation.serviceDate === date[0].serviceDate ? (
                                <span className="spa-loading-text-container reserve-loading">
                                    <img
                                        alt="Loader-spinner"
                                        width="25px"
                                        height="25px"
                                        src={LoaderImg}
                                    />
                                    <span className="services-loading-text"></span>
                                </span>
                            ) : inCartClass ? (
                                <div className="Reserve-card-price font-size-p2 gotham-xn-medium no-pad-margin">
                                    <span className="font-size-p15 gotham-xn-medium">Reserved</span>
                                </div>
                            ) : (
                                <>
                                    <div className="Reserve-card-port font-size-p2 gotham-xn-medium no-pad-margin">
                                        {location}
                                    </div>
                                    <div className="Reserve-card-price font-size-p2 gotham-xn-medium no-pad-margin">
                                        {`from  `}
                                        <sup className="font-size-p0 gotham-xn-medium">
                                            {`${ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} `}
                                        </sup>
                                        <span className="font-size-p10 gotham-xn-medium">
                                            {date.minPrice}
                                        </span>
                                    </div>
                                </>
                            )}
                            {inCartClass ? (
                                <div className="red font-size-p2 gotham-xn-medium no-pad-margin">
                                    Remove
                                </div>
                            ) : (
                                <div className="Reserve-card-times-text font-size-p2 gotham-xn-medium no-pad-margin">
                                    Reserve
                                </div>
                            )}
                        </div>
                    </button>
                </li>
            );
        });
    }
    return (
        <fieldset>
            <legend className="visuallyhidden">Choose a Date and Time</legend>
            <ul className="availability-dates-row row list-style">{reservationDatesCards}</ul>
        </fieldset>
    );
};

export default ReservationDates;
